import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { MakeUBLInvoice } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SOP004 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_SupplierPaymentOrder);
    const [invoice, setInvoice] = useState<any>({});
    const [props, setProps] = useState<any>({});

    const [modalConfAdd, setModalConfAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(bean.observations)
        }

        if (configProcedure?._pushProps) {
            let x = {
                IDUBLInvoice: invoice.IDUBLInvoice,
                UBLIssueDate: invoice.IssueDate,
                UBLTotalInvoiceAmount: invoice.TotalInvoiceAmount
            }
            configProcedure?._pushProps(x)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(bean)
        }
        toast.success('Factura agregada')
    }

    const AgregarFactura = () => {
        instance.addUBLInvoiceToAdquisitionContract(props.IDSupplierPaymentOrder, props.SupplierPaymentOrderDate, invoice.IDUBLInvoice, invoice.IssueDate, bean.observations, _single.getAccountID(), props.IDThirdBankingAccount ? props.IDThirdBankingAccount : bean.IDThirdBankingAccount).then(
            (resp: any) => {
                if (resp) {
                    setModalConfAdd({ ...modalConfAdd, "view": false });
                    onExportMap()
                }
            }
        )
            .catch(err => {
                toast.error(err)
            })
    }

    const closeModalAdd = () => {
        setBean({ ...bean, "observations": "" })
        if (!invoice.IDUBLInvoice) {
            toast.error("Debe seleccionar una factura valida")
        } else {
            setModalConfAdd({ ...modalConfAdd, "view": true, "name": "Confirmar Agregar Factura" });
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <MakeUBLInvoice idAccount={props.IDAccountSupplier} _onChange={(e) => { setInvoice(e) }} />
            </div>
            {invoice.TotalInvoiceAmount &&
                <div className="col-md-12 mt-4">
                    <BasicButton eventClick={() => { closeModalAdd() }} icon="ri-article-line" >Seleccionar Factura</BasicButton>
                </div>
            }


            <div className="col-md-12">
                <ModalConfirm modal={modalConfAdd} updateModal={setModalConfAdd} eventModal={AgregarFactura} >
                    <p>Esta seguro de agregar la Factura con ID {invoice.IDUBLInvoice} <br /> del proveedor {invoice.AccountSupplierNit} - {invoice.AccountSupplierName}</p>
                    <div className="row">
                        <div className="col-12">
                            <label>Observaciones</label>
                            <textarea name="observations" className="form-control" value={bean.observations} onChange={(e) => { setBean({ ...bean, "observations": e.target.value }) }} />
                        </div>
                        <div className="col-12">
                            {(!props.IDThirdBankingAccount) &&
                                <ThirdBankingAccountEditor label="Cuenta Bancaria del Tercero" idSelector={bean.IDThirdBankingAccount} idselectorAccount={props.IDAccountSupplier} onChange={(e) => { setBean({ ...bean, "IDThirdBankingAccount": e }) }} />
                            }
                        </div>
                    </div>
                </ModalConfirm>
            </div>
        </div>
    )
}